/** @module Enums */ /** typedoc */

export enum ReleaseContributorRoleEnum {
    Actor = 'Actor',
    Arranger = 'Arranger',
    Choir = 'Choir',
    Conductor = 'Conductor',
    Engineer = 'Engineer',
    Ensemble = 'Ensemble',
    Mixer = 'Mixer',
    Orchestra = 'Orchestra',
    Producer = 'Producer',
    Remixer = 'Remixer',
    Soloist = 'Soloist',
}
